/**
 * RESPONSIBILITY: the invitation at the foot of the Leadership page.
 *
 * Its own section rather than three more fields on the team band above it, because it
 * is a different thing being said and it gets its own pencil where it is shown.
 *
 * No @EditableBy, so WRITE defaults to NONE — admin only.
 */
import { Section, Text, Paragraph, Link } from '@framework/core/decorators';
import { SectionName } from '../section-names';
import { LINK_HINT } from '../hints';

@Section({ name: SectionName.LeadershipVisit, label: 'Leadership · Come and meet us' })
export class LeadershipVisitSection {
  @Text({ label: 'Title', maxLength: 300, default: 'Come and meet us' })
  heading!: string;

  @Paragraph({ label: 'Text', maxLength: 4000, rows: 2 })
  body!: string;

  @Text({ label: 'Button text', maxLength: 120, default: 'Contact us', group: 'Button' })
  ctaLabel!: string;

  @Link({ label: 'Button link', group: 'Button', description: LINK_HINT })
  ctaHref!: string;
}
